var map = {
	"./CREATIVITY.png": 6050,
	"./Combo_Chart.png": 3441,
	"./EXPERIENCE.png": 4584,
	"./Facebook.png": 1032,
	"./GIF.png": 4064,
	"./Instagram.png": 8834,
	"./Line.png": 622,
	"./Line2.png": 7086,
	"./LinkedIn2.png": 7574,
	"./MessageBot.png": 3248,
	"./Next.png": 6411,
	"./SATISFACTION.png": 4572,
	"./Search-icon.png": 9756,
	"./Shopping_Cart.png": 9375,
	"./Twitter.png": 8895,
	"./alishba.png": 8364,
	"./amna-nazakat.png": 2022,
	"./app-developer.png": 1722,
	"./arrow-down.png": 7648,
	"./back-end.png": 4421,
	"./bgimage.png": 4802,
	"./circle.png": 6416,
	"./circle2.png": 9904,
	"./comas.png": 3605,
	"./designer.png": 9463,
	"./e-com.gif": 4556,
	"./fb-blue.png": 4707,
	"./fb.png": 6480,
	"./female.png": 2312,
	"./forgedrift-icon.png": 8486,
	"./forgedrift.png": 18,
	"./front-end.png": 7503,
	"./globe.png": 2189,
	"./happy.png": 9808,
	"./illustration.png": 8970,
	"./insta-blue.png": 1066,
	"./insta.png": 5979,
	"./linkedin-blue.png": 7473,
	"./linkedin.png": 838,
	"./location.png": 1857,
	"./logo.png": 5549,
	"./male.png": 5091,
	"./map.png": 1704,
	"./mern.png": 682,
	"./naeem.png": 9928,
	"./sajawal.png": 2171,
	"./software-eng.png": 7468,
	"./x-blue.png": 7257,
	"./x.png": 9438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;